import React from 'react';

const services = [
  { id: 1, name: 'Construcción Residencial', description: 'Construcción de casas y edificios residenciales.' },
  { id: 2, name: 'Renovaciones', description: 'Servicios de renovación y remodelación para hogares y oficinas.' },
  { id: 3, name: 'Diseño de Interiores', description: 'Servicios de diseño de interiores para espacios residenciales y comerciales.' },
  { id: 4, name: 'Paisajismo', description: 'Diseño y mantenimiento de jardines y espacios exteriores.' },
  { id: 5, name: 'Instalaciones Eléctricas', description: 'Servicios de instalación y mantenimiento eléctrico.' },
  { id: 6, name: 'Plomería', description: 'Instalación y reparación de sistemas de plomería.' },
];

const Services = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Nuestros Servicios</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((service) => (
          <div key={service.id} className="border p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-2">{service.name}</h2>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;